import * as yup from 'yup';
import { FILE_TOO_LARGE_PATH, FILE_UNSUPPORTED_FORMAT_PATH, MAX_FILE_SIZE,
     ONLY_LETTERS_HEBREW_OR_ENGLISH_PERMITED_PATH, PERSON_ID_INVALID_PATH, REQUIRED_FIELD_PATH, SUPPORTED_FORMATS } from "../../errorMessages";
import validatorPersonId from '../../../helpers/validates/validatorPersonId';
import { IFileDataBase64 } from '../../../interface/fileDataBase64.interface';

export const yupObjectPersonDetails = {
    privateName: yup.string()
        .required(REQUIRED_FIELD_PATH)
        .matches(/^[\u0590-\u05FFa-zA-Z\s]+$/, ONLY_LETTERS_HEBREW_OR_ENGLISH_PERMITED_PATH),
    familyName: yup.string()
        .required(REQUIRED_FIELD_PATH)
        .matches(/^[\u0590-\u05FFa-zA-Z\s]+$/, ONLY_LETTERS_HEBREW_OR_ENGLISH_PERMITED_PATH),
    id: yup.string()
        .required(REQUIRED_FIELD_PATH)
        .test('valid-id', PERSON_ID_INVALID_PATH, value => validatorPersonId(value)),
    scanId: yup.mixed()
        .nonNullable()
        .required(REQUIRED_FIELD_PATH)
        .test(
            "FILE_SIZE",
            FILE_TOO_LARGE_PATH,
            (value: IFileDataBase64) => {

                return !value || (value && value.size <= MAX_FILE_SIZE)
            })
        .test(
            "FILE_FORMAT",
            FILE_UNSUPPORTED_FORMAT_PATH,
            (value: IFileDataBase64) => {

                return !value || (value && SUPPORTED_FORMATS.includes(value.contentType))
            }
        ),
    additionalPersonIdFile: yup.mixed()
        .when("hasAdditionalPersonIdFile", (hasAdditionalPersonIdFile, schema) => {

            if (Array.isArray(hasAdditionalPersonIdFile) && hasAdditionalPersonIdFile.length > 0) {
                const hasAddiPerFileBool = hasAdditionalPersonIdFile[0];

                if (!hasAddiPerFileBool) {
                    return schema.notRequired();
                }
            }

            return (
                schema
                    .nonNullable()
                    .required(REQUIRED_FIELD_PATH)
                    .test(
                        "FILE_SIZE",
                        FILE_TOO_LARGE_PATH,
                        (value: IFileDataBase64) => {
       
                            return !value || (value && value.size <= MAX_FILE_SIZE)
                        }
                    )
                    .test(
                        "FILE_FORMAT",
                        FILE_UNSUPPORTED_FORMAT_PATH,
                        (value: IFileDataBase64) => {

                            return !value || (value && SUPPORTED_FORMATS.includes(value.contentType))
                        }
                    )
            );
        }),
}